export default "__VITE_ASSET__BzeYpl8H__"